<script lang="ts">
    import { run } from 'svelte/legacy';

    import flatpickr from "flatpickr";
    import { onMount } from "svelte";
    import jQuery from "jquery";


    


    interface Props {
        autoUpdateMode?: boolean;
        //@TODO implement supports autoUpdateMode
        supportsAutoUpdateMode?: boolean;
        from: Date;
        to: Date;
        aggregation?: string;
        class?: string;
    }

    let {
        autoUpdateMode = $bindable(false),
        supportsAutoUpdateMode = true,
        from = $bindable(),
        to = $bindable(),
        aggregation = $bindable("10min"),
        class: CssClass =  ""
    }: Props = $props();


    let myRoot: HTMLElement = $state();

    let fp;
    onMount(() => {

        fp = flatpickr(".date-picker", {
            enableTime: true,
            altInput: false,
            mode : "range",
            onClose: function(selectedDates: Date[], dateStr: string, instance){
                from = selectedDates[0];
                to = selectedDates[1];
            }
        });

        fp.setDate([from, to]);
        changeAutoUpdateMode(autoUpdateMode);
    });

    let updateDates = (f: Date, t: Date) => {
        if(!fp) {
            return;
        }
        fp.setDate([from, to]);
        if(!autoUpdateMode) {
            let deltaMilis = to.getTime() - from.getTime();
            let mins = deltaMilis / 1000 / 60;
            let hours = mins / 60;
            let days = hours / 24;

            if(days > 60) {
                // weeks
                aggregation = "7d";
            } else if(days > 3) {
                // days
                aggregation = "1d";
            } else if(hours > 8) {
                // hourse
                aggregation = "1h";
            } else if(hours > 2) {
                // 15 mins
                aggregation = "15min";
            } else if(mins > 30) {
                // 5 mins
                aggregation = "5min";
            } else {
                // mins
                aggregation = "1min";
            }
        }
    };


    function changeAutoUpdateMode(v: boolean) {
        if(!fp) {
            return;
        }
        let nodesEnableWithAutoUpdate = jQuery(myRoot).find(".onlyautoupdate");
        let nodesDisableWithAutoUpdate = jQuery(myRoot).find(".notautoupdate");
        
        if(v) {
            nodesDisableWithAutoUpdate.attr("disabled", "disabled");
            nodesEnableWithAutoUpdate.removeAttr("disabled");
        } else {
            nodesEnableWithAutoUpdate.attr("disabled", "disabled");
            nodesDisableWithAutoUpdate.removeAttr("disabled");
        }
        
    }

    run(() => {
        changeAutoUpdateMode(autoUpdateMode);
    });
    run(() => {
        updateDates(from, to);
    });
</script>

<div bind:this={myRoot} class="{CssClass}">
    <div class="input-group px-2">
        <input name="timerangepicker" type="text" class="form-control date-picker notautoupdate" />
        <div class="input-group-text">
            <input class="form-check-input me-4" type="checkbox" role="switch" id="autouupdate" bind:checked={autoUpdateMode}>
            <label class="form-check-label" for="autouupdate">Auto Update</label>            
        </div>
        <div class="col-auto btn-group" role="group" aria-label="Time Interval">
            <input
                bind:group={aggregation}
                type="radio"
                class="btn-check onlyautoupdate"
                name="timeAggregationInterval"
                id="timeAggregationInterval1min"
                value="1min"
                data-theme-control="timeAggregationIntervalControl"
            />
            <label
                class="btn btn-outline-primary col-3 rounded-0"
                for="timeAggregationInterval1min"
            >
                1min
            </label>

            <input
                bind:group={aggregation}
                type="radio"
                class="btn-check onlyautoupdate"
                name="timeAggregationInterval"
                id="timeAggregationInterval5min"
                value="5min"
                data-theme-control="timeAggregationIntervalControl"
            />
            <label
                class="btn btn-outline-primary col-3 rounded-0"
                for="timeAggregationInterval5min"
            >
                5min
            </label>

            <input
                bind:group={aggregation}
                type="radio"
                class="btn-check onlyautoupdate"
                checked
                name="timeAggregationInterval"
                id="timeAggregationInterval10min"
                value="10min"
                data-theme-control="timeAggregationIntervalControl"
            />
            <label
                class="btn btn-outline-primary col-3 rounded-0 rounded-end-1"
                for="timeAggregationInterval10min"
            >
                10min
            </label>
        </div>
    </div>
    <div class="row justify-content-end my-6">

    </div>
</div>